import React from "react";

const ArrowBack = () => {
  return (
    <svg role="img" aria-label="arrow back" width="24" height="24" viewBox="0 0 24 24" fill="#576579">
        <path d="M21.925 12.35a.75.75 0 0 1-.75.75H5.55l4.325 4.325a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225l-5.6-5.6a.762.762 0 0 1-.175-.25.734.734 0 0 1-.05-.275c0-.1.017-.192.05-.275a.762.762 0 0 1 .175-.25l5.6-5.6A.72.72 0 0 1 9.35 6c.2 0 .375.075.525.225a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525L5.55 11.6h15.625a.75.75 0 0 1 .75.75Z"/>
    </svg>
  );
};

export default ArrowBack;
